import { RescaleConfig } from '../types';

const DEFAULT_CONFIG: RescaleConfig = {
  serverUrl: 'https://cdn.vallegalbarro.beeapp.es/api',
  defaultFormat: 'webp',
  defaultQuality: 80,
  presets: {
    thumbnail: {
      width: 150,
      height: 150,
      quality: 80,
      format: 'webp'
    },
    small: {
      width: 320,
      quality: 80,
      format: 'webp'
    },
    medium: {
      width: 640,
      quality: 80,
      format: 'webp'
    },
    large: {
      width: 1024,
      quality: 80,
      format: 'webp'
    },
    banner: {
      width: 1920,
      quality: 80,
      format: 'webp'
    }
  },
  defaultBreakpoints: [320, 640, 768, 1024, 1280, 1536, 1920],
  placeholderWidth: 20,
  defaultSizes: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw'
};

let config = { ...DEFAULT_CONFIG };

/**
 * Configura el servicio rescale
 * @param newConfig Configuración parcial para actualizar
 * @returns Configuración actualizada
 */
export const configureRescale = (newConfig: Partial<RescaleConfig>): RescaleConfig => {
  config = {
    ...config,
    ...newConfig,
    presets: {
      ...config.presets,
      ...(newConfig.presets || {})
    }
  };
  
  return config;
};

/**
 * Obtiene la configuración actual
 * @returns Configuración actual
 */
export const getRescaleConfig = (): RescaleConfig => {
  return config;
};

export default config; 